import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { API_BASE_URL } from '../injection-tokens';
import { SupplierInfoModel } from '../models/supplier-info.model';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  private http = inject(HttpClient);
  private apiBaseUrl = inject(API_BASE_URL);
  private cache$: Observable<SupplierInfoModel> | null = null;

  /**
   * Retrieves the supplier data, using a cached value if available.
   * @returns The result as an observable.
   */
  getSupplierData(): Observable<SupplierInfoModel> {
    this.cache$ ??= this.createRequest();
    return this.cache$;
  }

  /**
   * Refreshes the supplier data by creating a new request and updating the cache.
   * @returns The result as an observable.
   */
  refreshSupplierData(): Observable<SupplierInfoModel> {
    this.cache$ = this.createRequest();
    return this.cache$;
  }

  private createRequest(): Observable<SupplierInfoModel> {
    return this.http.get<SupplierInfoModel>(`${this.apiBaseUrl}/v1/supplier`).pipe(shareReplay(1));
  }
}
